import {
    SET_EDITED_ENTITY,
    UPDATE_ENTITY_FIELD,
    REST_COVER_IMAGE_UPLOADED,
    LOGO_IMAGE_UPLOADED,
    MENU_ITEM_IMAGE_UPLOADED,
    SAVE_GLOBAL_DISCOUNT,
    SAVE_SUBSCRIPTION,
    ADD_WORKER_TO_COMPANY,
    GRANT_PAYMENT_PERMISSION,
    ADD_MEMBER_TO_LOYALTY_PROGRAM,
    ADD_RESTAURANT_TO_LOYALTY_PROGRAM,
    ISSUE_BENEFIT,
    UPDATE_ISSUED_BENEFIT,
    SAVE_CAMPAIGN,
    SAVE_BENEFIT,
    SAVE_BUDGET_GROUP,
    SAVE_GROUP,
    SAVE_CATEGORY,
    SAVE_ITEM,
    SAVE_REWARD,
    SAVE_CHAIN,
    SAVE_RESTAURANT,
    SAVE_COMPANY,
    SAVE_DASHBOARD_USER,
    UPLOAD_MENU_JSON,
    INVOICE_SENT,
    SAVE_MENU_CATEGORY,
    SAVE_MENU_ITEM,
    SAVE_KIOSK,
    SAVE_WEBSITE,
    SAVE_BRAND
} from '../actions/types';

const INITIAL_STATE = {
    type: null,
    entity: null,
    extra: null,
    dirtyFields: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_EDITED_ENTITY:
            return { ...state, ...action.payload, dirtyFields: [] };
        case UPDATE_ENTITY_FIELD:
            if (action.payload.key.includes('[') && action.payload.key.includes(']')) {
                var fieldKey = action.payload.key.split('[')[0];
                return {
                    ...state,
                    dirtyFields: updateDirtyFields(state.dirtyFields, fieldKey),
                    entity: {
                        ...state.entity,
                        [fieldKey]: state.entity[fieldKey].map((item, index) => Number(action.payload.key.substring(action.payload.key.lastIndexOf('[') + 1, action.payload.key.lastIndexOf(']'))) === index ? action.payload.value : item)
                    }
                };
            }
            if (action.payload.key.includes('.')) {
                var [key, subkey] = action.payload.key.split('.');
                return {
                    ...state,
                    dirtyFields: updateDirtyFields(state.dirtyFields, key),
                    entity: {
                        ...state.entity,
                        [key]: {
                            ...state.entity[key],
                            [subkey]: action.payload.value
                        }
                    }
                };
            }
            return { ...state, dirtyFields: updateDirtyFields(state.dirtyFields, action.payload.key), entity: { ...state.entity, [action.payload.key]: action.payload.value } };
        case MENU_ITEM_IMAGE_UPLOADED:
        case REST_COVER_IMAGE_UPLOADED:
            return {
                ...state,
                dirtyFields: updateDirtyFields(state.dirtyFields, 'imageGuid'),
                entity: {
                    ...state.entity,
                    imageGuid: action.payload.imageGuid,
                    imageUrl: action.payload.imageUrl,
                }
            };
        case LOGO_IMAGE_UPLOADED:
            return {
                ...state,
                dirtyFields: updateDirtyFields(state.dirtyFields, 'logoGuid'),
                entity: {
                    ...state.entity,
                    logoGuid: action.payload.imageGuid,
                    thumbnail: action.payload.imageUrl,
                }
            };
        case SAVE_GLOBAL_DISCOUNT:
        case SAVE_SUBSCRIPTION:
        case ISSUE_BENEFIT:
        case UPDATE_ISSUED_BENEFIT:
        case ADD_WORKER_TO_COMPANY:
        case GRANT_PAYMENT_PERMISSION:
        case ADD_MEMBER_TO_LOYALTY_PROGRAM:
        case ADD_RESTAURANT_TO_LOYALTY_PROGRAM:
        case SAVE_CAMPAIGN:
        case SAVE_BENEFIT:
        case SAVE_BUDGET_GROUP:
        case SAVE_GROUP:
        case SAVE_CATEGORY:
        case SAVE_ITEM:
        case SAVE_REWARD:
        case SAVE_CHAIN:
        case SAVE_RESTAURANT:
        case SAVE_COMPANY:
        case SAVE_DASHBOARD_USER:
        case UPLOAD_MENU_JSON:
        case INVOICE_SENT:
        case SAVE_MENU_CATEGORY:
        case SAVE_MENU_ITEM:
        case SAVE_KIOSK:
        case SAVE_WEBSITE:
        case SAVE_BRAND:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
};

function updateDirtyFields(fields, field) {
    return fields.filter(f => f !== field).concat(field);
}
